import script from "./billingRulePage.vue?vue&type=script&setup=true&lang=js"
export * from "./billingRulePage.vue?vue&type=script&setup=true&lang=js"

import "./billingRulePage.vue?vue&type=style&index=0&id=7362c19a&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7362c19a"]])

export default __exports__